import React from 'react'
import { FileText, Cat, BookOpen } from 'lucide-react'
import '../../css/chi.scss'
import './study-ide.scss'

// Decorative, blurred /chi shell used as the backdrop behind modals (instructions,
// surveys, quiz, booking). Static and non-interactive.
const FADE_CODE = `import trio

async def timer() -> None:
    seconds = 1
    while True:
        await trio.sleep(1)
        print(f"{seconds}s")
        seconds += 1

async def task1():
    print("Starting...")
    with trio.move_on_after(2.5):
        async with trio.open_nursery() as nursery:
            nursery.start_soon(timer)
    print("Completed!")`

export default function ChiBackdrop () {
  return (
    <div className="chi-root study-chi study-backdrop" aria-hidden="true">
      <header className="chi-topbar">
        <div className="chi-topbar__back study-chi__kind">TASK</div>
        <div className="chi-topbar__center">Asynchronous Programming with Trio</div>
        <div className="chi-topbar__right"><span className="study-chi__timer">15:00</span></div>
      </header>
      <div className="chi-body">
        <section className="chi-desc">
          <nav className="chi-rail">
            <div className="chi-rail__item is-active"><FileText size={20} strokeWidth={1.8} /><span>DESC</span></div>
            <div className="chi-rail__item"><Cat size={20} strokeWidth={1.8} /><span>COSMO</span></div>
            <div className="chi-rail__item"><BookOpen size={20} strokeWidth={1.8} /><span>DOCS</span></div>
          </nav>
          <div className="chi-desc__content"><div className="study-backdrop__lines" /></div>
        </section>
        <div className="chi-divider" />
        <section className="chi-editor-side">
          <div className="chi-ed-tabs"><div className="chi-ed-tab">main.py</div><div className="chi-ed-runtime"><span>Python 3 · Trio</span></div></div>
          <div className="chi-editor"><pre className="study-backdrop__code">{FADE_CODE}</pre></div>
          <div className="chi-console"><div className="chi-console__tabs"><div className="chi-console__tab is-active">TERMINAL</div></div></div>
        </section>
      </div>
    </div>
  )
}
